import { Directive, HostListener, Input, Output, EventEmitter, ElementRef } from '@angular/core';

@Directive({
  selector: '[appResize]'
})
export class ResizeDirective {
  oldY = 0;
  oldX = 0;

  minWidth = 200;
minHeight = 120; 

  isGrabbing = false;

  @Input() height: number | null = null;
  @Input() width: number | null = null;
  @Input() positionX: number = 0;
  @Input() positionY: number = 0;

  @Output() heightChange = new EventEmitter<number | null>();
  @Output() widthChange = new EventEmitter<number | null>();

  constructor(private elementRef: ElementRef) { }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isGrabbing) return;

    const containerElement = document.getElementById('dummyContainer');
    if (!containerElement) return;

    // Se vier null (auto), garante que temos um número para trabalhar
    if (this.height == null || Number.isNaN(this.height)) {
      const dialogDiv = this.elementRef.nativeElement.parentNode as HTMLElement;
      this.height = dialogDiv?.clientHeight ?? this.minHeight;
    }
    if (this.width == null || Number.isNaN(this.width)) {
      const dialogDiv = this.elementRef.nativeElement.parentNode as HTMLElement;
      this.width = dialogDiv?.clientWidth ?? this.minWidth;
    }

    // Min limits
    if (this.height < this.minHeight) this.height = this.minHeight;
    if (this.width < this.minWidth) this.width = this.minWidth;

    const dialogDiv = this.elementRef.nativeElement.parentNode as HTMLElement;
    dialogDiv.style.userSelect = 'none';

    const containerWidth = containerElement.clientWidth;
    const containerHeight = containerElement.clientHeight;

    // HEIGHT
    if (this.height <= containerHeight) {
      if (event.clientY >= this.minHeight) {
        this.height = this.height + (event.clientY - this.oldY);
      } else {
        this.height = this.minHeight;
      }

      if (this.height > containerHeight - this.positionY) {
        this.height = containerHeight - this.positionY;
      }
    } else {
      this.height = containerHeight;
    }

    // WIDTH
    if (this.width <= containerWidth - this.positionX) {
      if (event.clientX >= this.minWidth) {
        this.width = this.width + (event.clientX - this.oldX);
      } else {
        this.width = this.minWidth;
      }

      if (this.width > containerWidth - this.positionX) {
        this.width = containerWidth - this.positionX;
      }
    } else {
      this.width = containerWidth;
    }

    // emite valores (a partir daqui o dialog deixa de ser auto e fica “fixo”)
    this.heightChange.emit(this.height);
    this.widthChange.emit(this.width);

    this.oldY = event.clientY;
    this.oldX = event.clientX;
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.isGrabbing = false;
    const dialogDiv = this.elementRef.nativeElement.parentNode as HTMLElement;
    dialogDiv.style.userSelect = 'auto';
  }

  @HostListener('mousedown', ['$event'])
onMouseDown(event: MouseEvent) {
  this.isGrabbing = true;
  this.oldY = event.clientY;
  this.oldX = event.clientX;

  const dialogDiv = this.elementRef.nativeElement.parentNode as HTMLElement;

  // se estava auto, captura o tamanho atual
  if (this.height == null) this.height = dialogDiv?.clientHeight ?? 0;
  if (this.width == null) this.width = dialogDiv?.clientWidth ?? 0;

  const bar = dialogDiv.querySelector('.window-bar') as HTMLElement | null;   // ajusta ao teu selector real
  const body = dialogDiv.querySelector('.dialog-body') as HTMLElement | null;

  const barH = bar?.offsetHeight ?? 0;

  // se já há conteúdo, isto dá-te o mínimo real “sem cortar”
  const contentH = body ? body.scrollHeight : (dialogDiv.clientHeight - barH);

  // ✅ mínimo permitido no resize = altura atual necessária
  // (com um mínimo de segurança pequeno)
  this.minHeight = Math.max(barH + 40, barH + contentH);

  // largura mínima também pode ser dinâmica se quiseres:
  const contentW = body ? body.scrollWidth : dialogDiv.clientWidth;
  this.minWidth = Math.max(200, contentW);

  // garante coerência
  if (this.height < this.minHeight) this.height = this.minHeight;
  if (this.width < this.minWidth) this.width = this.minWidth;

  this.heightChange.emit(this.height);
  this.widthChange.emit(this.width);
}

}
